// extracted by mini-css-extract-plugin
module.exports = {"root":"settings_root__3-8KX","title":"settings_title__2q1s7","settings":"settings_settings__3YxUy","setting":"settings_setting__10vdM"};